import React, { memo } from 'react';
import styled from 'styled-components';
import { ChartNavItem } from './chartNavItem';
import { HourlyForecastChartTypes } from '../../common/types';

export const ForecastChartNav = memo(() => {
    return (
        <Container>
            <ChartNavItem key={HourlyForecastChartTypes.precip} graphNavItemName={HourlyForecastChartTypes.precip} />
            <ChartNavItem key={HourlyForecastChartTypes.temp} graphNavItemName={HourlyForecastChartTypes.temp} />
        </Container>
    );
});

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    position: absolute;
    width: 109px;
    left: 25px;
    bottom: 17px;
    z-index: 99;
`;